import { useAtomValue } from "jotai";
import { mergeClass } from "../../utils";
import { Button } from "../Button";
import { DisplayValue } from "../DisplayValue";
import _ from "lodash";
import { usePublisher } from "./usePublisher";
import { publishGroups } from "./publishConfig";
import { useState } from "react";
import { Spinner } from "../Loader";
import { hostDataAtom } from "../../atoms";
import { Banner } from "./PublishBanner";
import { getGroupDataFromModel } from "./utils";

const PublishBanner = ({
  appGroup,
}: {
  appGroup: keyof typeof publishGroups;
}): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups[appGroup].atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = usePublisher(appGroup, setIsPublishing);
  const hostData = useAtomValue(hostDataAtom);
  const baseUrl = `https://${hostData.aws_bucket}.s3.${hostData.aws_region}.amazonaws.com/${hostData.s3_endpoints_path}`;
  const endpointUrl = `${baseUrl}/${appGroup}.json`;
  return (
    <Banner
      published={upToDate}
      isPublishing={isPublishing}
      handlePublishPressed={() => publish()}
      endpointUrl={endpointUrl}
    />
  );
};

const PublishBannerByModel = ({ modelName }: { modelName: string }) => (
  <PublishBanner
    appGroup={
      getGroupDataFromModel(modelName).group as keyof typeof publishGroups
    }
  />
);

const NavPublishSection = ({
  appGroup,
}: {
  appGroup: keyof typeof publishGroups;
}): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups[appGroup].atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = usePublisher(appGroup, setIsPublishing);
  return (
    <div className="pb-4 space-y-2 w-full">
      <div
        className={mergeClass("font-bold text-grayBg h-8", {
          "text-unpublishedNav": !upToDate,
        })}
      >
        {upToDate
          ? "Published content is up to date"
          : "You have unpublished changes"}
      </div>
      <Button
        className="text-sm mt-2 flex gap-2"
        disabled={isPublishing}
        onClick={() => publish()}
      >
        Publish {isPublishing && <Spinner />}
      </Button>
    </div>
  );
};

const HomePublishSection = ({
  appGroup,
}: {
  appGroup: keyof typeof publishGroups;
}): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups[appGroup].atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = usePublisher(appGroup, setIsPublishing);
  return (
    <div className="mt-2 text-sm">
      <DisplayValue name="Last Modified" value={publishState.lastchange} />
      <DisplayValue
        name="Last Published"
        value={publishState.lastpublish}
        className={
          upToDate ? "text-unpublishedHome font-bold" : "text-primaryColor"
        }
      />
      <Button
        className="text-sm mt-2 flex gap-2"
        disabled={isPublishing}
        onClick={() => publish()}
      >
        Push Changes {isPublishing && <Spinner />}
      </Button>
    </div>
  );
};

export {
  HomePublishSection,
  NavPublishSection,
  PublishBannerByModel,
  PublishBanner,
};
